import React from "react"

const FavoriteStar = ({ color = "#1666B6" }) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.4388 3.794L17.4535 9.90733C17.5235 10.052 17.6635 10.1547 17.8221 10.178L24.5655 11.158C24.9668 11.2187 25.1301 11.7133 24.8361 11.998L19.9641 16.7487C19.8475 16.8607 19.7961 17.024 19.8241 17.1827L20.9768 23.898C21.0468 24.2993 20.6221 24.6073 20.2628 24.416L14.2288 21.2427C14.0841 21.168 13.9161 21.168 13.7715 21.2427L7.73747 24.416C7.37813 24.6073 6.95813 24.2993 7.02347 23.898L8.17614 17.1827C8.20414 17.024 8.1528 16.8607 8.03613 16.7487L3.1548 11.9933C2.86547 11.7087 3.02413 11.214 3.42547 11.1533L10.1688 10.1733C10.3275 10.15 10.4675 10.0473 10.5375 9.90267L13.5521 3.78933C13.7388 3.43 14.2615 3.43 14.4388 3.794Z"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const NormalIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9999 7.71239C15.1458 6.45309 16.7828 5.64063 18.6244 5.64063C20.3432 5.64063 21.9802 6.37184 23.1261 7.63115C25.0904 9.74353 25.2541 12.6277 23.6172 14.9432C22.103 17.0556 15.3095 23.3115 13.9999 24.7333C12.6904 23.3115 5.89692 17.0556 4.38272 14.9026C2.74575 12.5871 2.90944 9.70291 4.87381 7.59052C6.01969 6.37184 7.69759 5.60001 9.37549 5.60001C11.2171 5.64063 12.8541 6.45309 13.9999 7.71239Z"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const RestaurantIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M14 11.48H23.66C23.8 10.6867 23.7533 9.84666 23.52 9.09999C22.3067 5.32 17.3133 4.06 14 4.06C10.6867 4.06 5.69332 5.32 4.52666 9.09999C4.29332 9.84666 4.19999 10.6867 4.38666 11.48H14Z"
        stroke="#333333"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4468 21.0933H5.64675C4.94675 21.0933 4.34009 21.7 4.34009 22.4V23.1467C4.34009 23.8467 4.90009 24.4533 5.64675 24.4533H22.1668C22.8668 24.4533 23.4734 23.8467 23.4734 23.1467V22.4C23.4734 21.7 22.9134 21.0933 22.1668 21.0933H20.6734"
        stroke="#333333"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.10669 12.74C5.32002 12.74 5.32002 14.4667 6.58002 14.4667C7.79336 14.4667 7.79336 12.74 9.05336 12.74C10.2667 12.74 10.2667 14.4667 11.5267 14.4667C12.74 14.4667 12.74 12.74 14 12.74C15.2134 12.74 15.2134 14.4667 16.4734 14.4667C17.6867 14.4667 17.6867 12.74 18.9467 12.74C20.16 12.74 20.16 14.4667 21.42 14.4667C22.6334 14.4667 22.6334 12.74 23.8934 12.74"
        stroke="#333333"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.5"
        d="M22.1668 15.9133H5.64675C4.94675 15.9133 4.34009 16.52 4.34009 17.22V17.9667C4.34009 18.6667 4.90009 19.2733 5.64675 19.2733H15.4468V21.3733C15.4468 22.0733 16.0068 22.6333 16.7068 22.6333C17.4068 22.6333 17.9668 22.0733 17.9668 21.3733V20.6267C17.9668 21.3267 18.5268 21.8867 19.2268 21.8867C19.9268 21.8867 20.4868 21.3267 20.4868 20.6267V19.2733H22.1668C22.8668 19.2733 23.4734 18.6667 23.4734 17.9667V17.22C23.4268 16.52 22.8668 15.9133 22.1668 15.9133Z"
        stroke="#333333"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

const MusicIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8024 20.7614C10.8301 19.4472 9.41117 18.3515 7.63317 18.314C5.85517 18.2765 4.39135 19.3115 4.36365 20.6257C4.33594 21.9398 5.75483 23.0356 7.53283 23.0731C9.31083 23.1105 10.7747 22.0756 10.8024 20.7614Z"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.4366 19.3466C21.4643 18.0324 20.0455 16.9367 18.2674 16.8992C16.4894 16.8617 15.0256 17.8967 14.9979 19.2108C14.9702 20.525 16.3891 21.6207 18.1671 21.6582C19.9451 21.6957 21.4089 20.6608 21.4366 19.3466Z"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.42 19.32L21.7467 4.94667L11.1067 6.39333L10.8267 20.7667"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.6534 8.30666L11.0601 9.75333"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const TheaterIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.2469 18.5733C25.2469 21.6067 21.3269 25.2933 19.1802 25.2933C17.0335 25.2933 13.1135 21.6533 13.1135 18.5733V12.3667C13.1135 10.78 15.8202 9.47333 19.1802 9.47333C22.5402 9.47333 25.2469 10.78 25.2469 12.3667V18.5733Z"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.167 18.5733C22.167 18.5733 21.9336 18.7133 21.2803 19.0867C20.8136 19.32 19.9736 19.4133 19.1803 19.4133C18.387 19.4133 17.547 19.32 17.0803 19.0867C16.3803 18.76 16.1936 18.5733 16.1936 18.5733C16.1936 18.5733 16.1003 19.18 16.3803 19.8333C16.6603 20.44 17.547 22.26 19.1803 22.3067C20.767 22.3067 21.7003 20.4867 21.9803 19.8333C22.2603 19.18 22.167 18.5733 22.167 18.5733Z"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.2935 15.3533C17.5468 14.5133 15.9135 14.6067 15.1201 15.3533"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.2869 15.3533C22.5402 14.5133 20.9069 14.6067 20.1135 15.3533"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.5"
      d="M14.8868 10.3203V5.6C14.8868 4.01333 12.1801 2.70667 8.82009 2.70667C5.46009 2.70667 2.75342 4.01333 2.75342 5.6V11.8067C2.75342 14.8867 6.67342 18.5267 8.82009 18.5267C10.0274 18.5267 11.7957 17.3605 13.112 15.8003"
      stroke="#333333"
      strokeMiterlimit="10"
    />
    <path
      opacity="0.5"
      d="M4.80664 8.86667C5.92664 9.19333 7.23331 8.26 7.51331 7.18667"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.5"
      d="M12.6469 8.86667C11.5269 9.19333 10.2202 8.26 9.94019 7.18667"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.5"
      d="M11.0134 12.7867C10.5934 12.1333 9.75342 11.8533 9.00675 11.8067C8.96008 11.8067 8.86675 11.8067 8.82008 11.8067C8.77342 11.8067 8.68008 11.8067 8.63342 11.8067C7.88675 11.8533 7.04675 12.0867 6.62675 12.7867C6.34675 13.16 5.88008 14.6067 6.58008 14.84C6.90675 14.9333 7.23342 14.6533 7.51342 14.5133C7.79342 14.3733 8.07342 14.28 8.40008 14.2333C8.54008 14.2333 8.68008 14.1867 8.86675 14.1867C9.00675 14.1867 9.14675 14.1867 9.33342 14.2333C9.66008 14.28 9.94008 14.3733 10.2201 14.5133C10.5001 14.6533 10.7801 14.9333 11.1534 14.84C11.7601 14.6067 11.2934 13.16 11.0134 12.7867Z"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const TvIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M18.3399 1.77333L13.9999 6.11333L9.65991 1.77333"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5933 7.74667V6.72C10.5933 6.39333 10.8733 6.11333 11.1999 6.11333H16.7999C17.1266 6.11333 17.4066 6.39333 17.4066 6.72V7.74667"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.3399 21.0933V24.36H2.65991V8.21333H25.3399V11.9933V21.0933Z"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.5"
      d="M19.6467 16.2867C19.6467 14.28 19.46 13.02 19.3667 12.1333C19.2733 11.2467 18.9467 10.78 18.1067 10.5C17.2667 10.2667 12.04 10.22 12.04 10.22C12.04 10.22 6.81335 10.2667 5.97335 10.5C5.13335 10.7333 4.80668 11.2 4.71335 12.1333C4.62002 13.0667 4.43335 14.3267 4.43335 16.2867C4.43335 18.2933 4.62002 19.5533 4.71335 20.44C4.80668 21.3267 5.13335 21.7933 5.97335 22.0733C6.81335 22.3533 12.04 22.3533 12.04 22.3533C12.04 22.3533 17.2667 22.3067 18.1067 22.0733C18.9467 21.84 19.2733 21.3733 19.3667 20.44C19.46 19.5533 19.6467 18.2933 19.6467 16.2867Z"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.4931 18.0133C23.1632 18.0133 23.7065 17.4701 23.7065 16.8C23.7065 16.1299 23.1632 15.5867 22.4931 15.5867C21.823 15.5867 21.2798 16.1299 21.2798 16.8C21.2798 17.4701 21.823 18.0133 22.4931 18.0133Z"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.4931 14C23.1632 14 23.7065 13.4568 23.7065 12.7867C23.7065 12.1166 23.1632 11.5733 22.4931 11.5733C21.823 11.5733 21.2798 12.1166 21.2798 12.7867C21.2798 13.4568 21.823 14 22.4931 14Z"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const MeetingIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.19336 16.1933V19.9267"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.19341 20.2067L4.99341 21.3267"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.19336 20.2067L13.3934 21.3267"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.5"
      d="M16.4733 13.44V16.1933H1.91333V3.78H16.4733V11.2933"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.5"
      d="M13.3934 9.98667C13.3934 7.65333 11.5267 5.78667 9.19341 5.78667C6.86008 5.78667 4.99341 7.65333 4.99341 9.98667C4.99341 12.32 6.86008 14.1867 9.19341 14.1867V9.98667H13.3934Z"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.9399 13.8133V24.22"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.0933 10.3133C22.2016 10.3133 23.1 9.41492 23.1 8.30667C23.1 7.19841 22.2016 6.3 21.0933 6.3C19.9851 6.3 19.0867 7.19841 19.0867 8.30667C19.0867 9.41492 19.9851 10.3133 21.0933 10.3133Z"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.0933 19.9267V24.22"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.4599 11.2933H13.5799C12.9733 11.2933 12.5066 11.76 12.5066 12.3667C12.5066 12.9733 12.9733 13.44 13.5799 13.44H18.5266V24.1733"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.94 13.44V17.6867C23.94 18.2933 24.4066 18.76 25.0133 18.76C25.62 18.76 26.0866 18.2933 26.0866 17.6867V12.7867C26.0866 11.9933 25.4333 11.34 24.64 11.34H22.96"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const CrowdIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M5.36657 16.7067C6.50059 16.7067 7.4199 15.7874 7.4199 14.6533C7.4199 13.5193 6.50059 12.6 5.36657 12.6C4.23254 12.6 3.31323 13.5193 3.31323 14.6533C3.31323 15.7874 4.23254 16.7067 5.36657 16.7067Z"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.91333 23.7533V21.28C1.91333 19.4133 3.40666 17.92 5.27333 17.92C7.13999 17.92 8.63333 19.4133 8.63333 21.28V23.7533"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.5"
      d="M10.0333 7.42001C11.1673 7.42001 12.0866 6.5007 12.0866 5.36667C12.0866 4.23265 11.1673 3.31334 10.0333 3.31334C8.89929 3.31334 7.97998 4.23265 7.97998 5.36667C7.97998 6.5007 8.89929 7.42001 10.0333 7.42001Z"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.81323 10.64C7.32657 9.42667 8.49323 8.58667 9.89323 8.58667C11.2932 8.58667 12.4599 9.42667 12.9732 10.64"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.5"
      d="M18.2933 7.42001C19.4273 7.42001 20.3466 6.5007 20.3466 5.36667C20.3466 4.23265 19.4273 3.31334 18.2933 3.31334C17.1593 3.31334 16.24 4.23265 16.24 5.36667C16.24 6.5007 17.1593 7.42001 18.2933 7.42001Z"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.0732 10.64C15.5866 9.42667 16.7532 8.58667 18.1532 8.58667C19.5532 8.58667 20.7199 9.42667 21.2332 10.64"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.5"
      d="M14.0467 16.7067C15.1808 16.7067 16.1001 15.7874 16.1001 14.6533C16.1001 13.5193 15.1808 12.6 14.0467 12.6C12.9127 12.6 11.9934 13.5193 11.9934 14.6533C11.9934 15.7874 12.9127 16.7067 14.0467 16.7067Z"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5933 23.7533V21.28C10.5933 19.4133 12.0866 17.92 13.9533 17.92C15.8199 17.92 17.3133 19.4133 17.3133 21.28V23.7533"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.5"
      d="M22.8199 16.7067C23.954 16.7067 24.8733 15.7874 24.8733 14.6533C24.8733 13.5193 23.954 12.6 22.8199 12.6C21.6859 12.6 20.7666 13.5193 20.7666 14.6533C20.7666 15.7874 21.6859 16.7067 22.8199 16.7067Z"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.3667 23.7533V21.28C19.3667 19.4133 20.86 17.92 22.7267 17.92C24.5934 17.92 26.0867 19.4133 26.0867 21.28V23.7533"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const PhoneIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.93999 10.22C9.98666 9.84666 11.7133 8.96 12.5533 8.4C13.16 7.98 11.48 3.91999 10.5467 3.49999C9.98666 3.26666 5.78666 3.59333 5.59999 5.55333C4.75999 12.6 11.9933 22.8667 18.8533 24.5467C20.7667 25.0133 22.4933 21.1867 22.4467 20.6267C22.4 19.6 19.1333 16.6133 18.5267 17.0333C17.6867 17.5933 16.2867 18.9467 15.9133 18.8533C14 18.48 9.56666 12.18 9.93999 10.22Z"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
  </svg>
)

const Preset1Icon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.0529 21.9999V2.0769H10.8909C10.3689 4.28091 8.13592 4.7739 6.56992 4.7739H5.81592V9.26891C8.30992 9.26891 9.12192 9.1239 10.0789 8.7759V21.9999H16.0529Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
)

const Preset2Icon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.9389 17.3601H11.9639C15.3279 15.4461 16.9229 14.4311 18.1989 13.0391C20.0259 11.0671 20.1999 9.32711 20.1999 8.19611C20.1999 4.80311 18.2569 1.78711 12.2829 1.78711C7.23694 1.78711 3.55394 3.61411 3.55394 9.21111V9.67511L9.44094 10.3711C9.26694 9.79111 9.23794 9.55911 9.23794 8.92111C9.23794 6.45611 10.6299 5.96311 11.7899 5.96311C13.5299 5.96311 14.1679 7.03611 14.1679 8.28311C14.1679 9.87811 13.0949 10.9221 11.9929 11.9371C10.7749 13.0391 9.46994 14.0251 8.13594 14.9821C6.59894 16.1131 5.00394 17.1861 3.40894 18.2301V22.0001H19.9389V17.3601Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
)

const Preset3Icon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.1613 13.851C10.5963 13.735 10.9153 13.706 11.7273 13.706C13.3223 13.706 14.9753 14.112 14.9753 15.794C14.9753 17.389 14.0183 18.317 11.9013 18.317C9.58126 18.317 8.79826 16.809 8.65326 14.982L3.11426 16.026C3.95526 21.101 7.49326 22.406 12.0173 22.406C17.8463 22.406 21.0363 20.173 21.0363 16.113C21.0363 13.068 18.9483 12.169 17.2083 11.676C19.3543 10.922 20.3983 9.41401 20.3983 7.326C20.3983 3.87501 17.3533 1.729 12.4233 1.729C7.46426 1.729 4.30326 3.61401 3.78126 8.37L9.26226 8.689C9.34926 7.906 9.58126 5.731 12.0463 5.731C14.1633 5.731 14.7433 6.891 14.7433 7.81901C14.7433 9.849 12.4523 9.994 11.4953 9.994C10.9153 9.994 10.7123 9.96501 10.1613 9.90701V13.851Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
)

const Preset4Icon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.693 17.8531V13.9091H18.141V2.0481H12.225L3.177 13.8801V17.8531H12.457V22.0001H18.141V17.8531H20.693ZM12.486 13.9091H7.933L12.486 7.7901V13.9091Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
)

const NotificationBell = ({ color = "#FF5E2B" }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.10938 13.6094H5.20312C5.26562 15.0234 6.39062 16.2891 8 16.2891C9.60156 16.2891 10.7344 15.0312 10.7969 13.6094H13.8828C14.6094 13.6094 15.0469 13.2344 15.0469 12.6641C15.0469 11.9062 14.3047 11.2344 13.6562 10.5859C13.1562 10.0703 13.0234 9.03125 12.9531 8.11719C12.8828 5.25 12.1094 3.375 10.1562 2.67188C9.89844 1.70312 9.09375 0.945312 8 0.945312C6.90625 0.945312 6.10156 1.70312 5.84375 2.67188C3.89062 3.375 3.11719 5.25 3.04688 8.11719C2.97656 9.03125 2.84375 10.0703 2.34375 10.5859C1.69531 11.2344 0.953125 11.9062 0.953125 12.6641C0.953125 13.2344 1.39062 13.6094 2.10938 13.6094ZM2.50781 12.4062V12.3203C2.66406 12.1016 3.10156 11.6875 3.48438 11.2578C4 10.6641 4.25 9.67188 4.3125 8.24219C4.39062 5.10156 5.32812 4.08594 6.57031 3.75C6.75781 3.70312 6.85938 3.60938 6.86719 3.42188C6.89844 2.65625 7.32812 2.13281 8 2.13281C8.67188 2.13281 9.10156 2.65625 9.13281 3.42188C9.14062 3.60938 9.24219 3.70312 9.42969 3.75C10.6641 4.08594 11.6094 5.10156 11.6797 8.24219C11.75 9.67188 12 10.6641 12.5156 11.2578C12.8984 11.6875 13.3281 12.1016 13.4844 12.3203V12.4062H2.50781ZM8 15.2031C7.125 15.2031 6.5 14.5859 6.44531 13.6094H9.55469C9.5 14.5781 8.875 15.2031 8 15.2031Z"
      fill={color}
    />
  </svg>
)

const AppRatingStar = ({ color = "#FF5E2B" }) => (
  <svg
    width="19"
    height="17"
    viewBox="0 0 19 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.3246 5.96819L12.3254 5.96831L17.4473 6.71267L13.7484 10.3195C13.7478 10.32 13.7473 10.3205 13.7467 10.3211C13.5325 10.5278 13.4413 10.8249 13.4911 11.1096C13.4912 11.11 13.4912 11.1105 13.4913 11.111L14.3664 16.2094L9.78264 13.7987L9.78265 13.7987L9.77923 13.797C9.52073 13.6635 9.21669 13.6635 8.95819 13.797L8.95819 13.797L8.95478 13.7987L4.37098 16.2094L5.2461 11.111C5.24618 11.1105 5.24626 11.1101 5.24633 11.1097C5.29612 10.825 5.20495 10.5278 4.99068 10.3211C4.99013 10.3205 4.98959 10.32 4.98904 10.3195L1.28286 6.70896L6.40463 5.96462L6.40547 5.96449C6.69438 5.92201 6.94603 5.73777 7.07394 5.47518C7.07427 5.47449 7.0746 5.4738 7.07494 5.47311L9.3641 0.831031L11.6551 5.47681C11.6554 5.47753 11.6558 5.47824 11.6561 5.47896C11.784 5.7415 12.0357 5.92571 12.3246 5.96819Z"
      stroke={color}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const ChevronRight = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.3636 16.9091L15.2727 12L10.3636 7.09094"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const ChargerIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0001 19.091C15.9163 19.091 19.091 15.9163 19.091 12.0001C19.091 11.9725 19.0908 11.945 19.0905 11.9175C19.0875 11.6561 18.8684 11.4546 18.6069 11.4546H5.39326C5.13183 11.4546 4.91263 11.6561 4.90965 11.9175C4.90934 11.945 4.90918 11.9725 4.90918 12.0001C4.90918 15.9163 8.08389 19.091 12.0001 19.091ZM5.10529 10.337C5.03365 10.6351 5.26915 10.9092 5.57571 10.9092H18.4245C18.731 10.9092 18.9665 10.6351 18.8949 10.337C18.1465 7.22318 15.3435 4.90918 12.0001 4.90918C8.65664 4.90918 5.85366 7.22317 5.10529 10.337ZM6.54562 12.8183C6.54562 12.6677 6.66772 12.5456 6.81835 12.5456H7.90926C8.05988 12.5456 8.18198 12.6677 8.18198 12.8183C8.18198 12.9689 8.05988 13.091 7.90926 13.091H6.81835C6.66772 13.091 6.54562 12.9689 6.54562 12.8183ZM9.0002 12.5456C8.84957 12.5456 8.72747 12.6677 8.72747 12.8183C8.72747 12.9689 8.84957 13.091 9.0002 13.091H10.0911C10.2417 13.091 10.3638 12.9689 10.3638 12.8183C10.3638 12.6677 10.2417 12.5456 10.0911 12.5456H9.0002ZM13.6364 12.8183C13.6364 12.6677 13.7585 12.5456 13.9091 12.5456H15C15.1507 12.5456 15.2728 12.6677 15.2728 12.8183C15.2728 12.9689 15.1507 13.091 15 13.091H13.9091C13.7585 13.091 13.6364 12.9689 13.6364 12.8183ZM16.0911 12.5456C15.9405 12.5456 15.8184 12.6677 15.8184 12.8183C15.8184 12.9689 15.9405 13.091 16.0911 13.091H17.182C17.3327 13.091 17.4548 12.9689 17.4548 12.8183C17.4548 12.6677 17.3327 12.5456 17.182 12.5456H16.0911Z"
      fill="#333333"
    />
  </svg>
)

const HIRight = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4366 9.81836H14.8911V13.0911H15.4366L15.982 12.5456V10.3638L15.4366 9.81836Z"
      fill="#333333"
    />
    <path
      d="M14.3458 9.81836L10.5276 10.0911V12.8184L14.3458 13.0911V9.81836Z"
      fill="#333333"
    />
    <path
      d="M9.85487 9.60869L8.53185 10.2702C8.08335 10.4944 7.80005 10.9528 7.80005 11.4543C7.80005 11.9557 8.08335 12.4141 8.53185 12.6384L9.85487 13.2999C10.1638 13.4543 10.5273 13.2297 10.5273 12.8843V10.0243C10.5273 9.67887 10.1638 9.45421 9.85487 9.60869Z"
      fill="#ADADAD"
    />
    <path
      d="M11.94 18.4474C12.187 18.5709 12.4873 18.4708 12.6108 18.2238C12.7343 17.9768 12.6342 17.6765 12.3872 17.553L11.94 18.4474ZM11.9197 17.8782L11.6961 18.3254L11.9197 17.8782ZM12.3388 18.1366L12.6458 18.5313L12.3388 18.1366ZM14.1182 9.81836V13.7182H15.1182V9.81836H14.1182ZM12.2229 17.5934L12.0319 17.7419L12.6458 18.5313L12.8368 18.3827L12.2229 17.5934ZM11.9416 17.7729H11.8265V18.7729H11.9416V17.7729ZM11.6961 18.3254L11.94 18.4474L12.3872 17.553L12.1433 17.431L11.6961 18.3254ZM12.1182 18.0646C12.1182 18.2814 11.89 18.4224 11.6961 18.3254L12.1433 17.431C11.6723 17.1955 11.1182 17.538 11.1182 18.0646H12.1182ZM11.8265 17.7729C11.9876 17.7729 12.1182 17.9035 12.1182 18.0646H11.1182C11.1182 18.4558 11.4353 18.7729 11.8265 18.7729V17.7729ZM12.0319 17.7419C12.0061 17.762 11.9743 17.7729 11.9416 17.7729V18.7729C12.1967 18.7729 12.4445 18.6879 12.6458 18.5313L12.0319 17.7419ZM14.1182 13.7182C14.1182 15.2332 13.4187 16.6633 12.2229 17.5934L12.8368 18.3827C14.2763 17.2632 15.1182 15.5418 15.1182 13.7182H14.1182Z"
      fill="#ADADAD"
    />
  </svg>
)

const HILeft = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.56343 9.81836H9.10889V13.0911H8.56343L8.01798 12.5456V10.3638L8.56343 9.81836Z"
      fill="#333333"
    />
    <path
      d="M9.65423 9.81836L13.4724 10.0911V12.8184L9.65423 13.0911V9.81836Z"
      fill="#333333"
    />
    <path
      d="M14.1451 9.60869L15.4681 10.2702C15.9166 10.4944 16.2 10.9528 16.2 11.4543C16.2 11.9557 15.9166 12.4141 15.4681 12.6384L14.1451 13.2999C13.8362 13.4543 13.4727 13.2297 13.4727 12.8843V10.0243C13.4727 9.67887 13.8362 9.45421 14.1451 9.60869Z"
      fill="#ADADAD"
    />
    <path
      d="M12.06 18.4474C11.813 18.5709 11.5127 18.4708 11.3892 18.2238C11.2657 17.9768 11.3658 17.6765 11.6128 17.553L12.06 18.4474ZM12.0803 17.8782L12.3039 18.3254L12.0803 17.8782ZM11.6612 18.1366L11.3542 18.5313L11.6612 18.1366ZM9.88184 9.81836V13.7182H8.88184V9.81836H9.88184ZM11.7771 17.5934L11.9681 17.7419L11.3542 18.5313L11.1632 18.3827L11.7771 17.5934ZM12.0584 17.7729H12.1735V18.7729H12.0584V17.7729ZM12.3039 18.3254L12.06 18.4474L11.6128 17.553L11.8567 17.431L12.3039 18.3254ZM11.8818 18.0646C11.8818 18.2814 12.11 18.4224 12.3039 18.3254L11.8567 17.431C12.3277 17.1955 12.8818 17.538 12.8818 18.0646H11.8818ZM12.1735 17.7729C12.0124 17.7729 11.8818 17.9035 11.8818 18.0646H12.8818C12.8818 18.4558 12.5647 18.7729 12.1735 18.7729V17.7729ZM11.9681 17.7419C11.9939 17.762 12.0257 17.7729 12.0584 17.7729V18.7729C11.8033 18.7729 11.5555 18.6879 11.3542 18.5313L11.9681 17.7419ZM9.88184 13.7182C9.88184 15.2332 10.5813 16.6633 11.7771 17.5934L11.1632 18.3827C9.72374 17.2632 8.88184 15.5418 8.88184 13.7182H9.88184Z"
      fill="#ADADAD"
    />
  </svg>
)

const CalendarIcon = () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.9375 14.5156H13.0625C14.625 14.5156 15.4141 13.7266 15.4141 12.1797V3.16406C15.4141 1.625 14.625 0.835938 13.0625 0.835938H2.9375C1.375 0.835938 0.578125 1.61719 0.578125 3.16406V12.1797C0.578125 13.7266 1.375 14.5156 2.9375 14.5156ZM2.86719 13.2266C2.21875 13.2266 1.86719 12.8906 1.86719 12.2109V5.30469C1.86719 4.63281 2.21875 4.28906 2.86719 4.28906H13.125C13.7656 4.28906 14.1328 4.63281 14.1328 5.30469V12.2109C14.1328 12.8906 13.7656 13.2266 13.125 13.2266H2.86719ZM6.5625 6.91406H6.99219C7.25781 6.91406 7.34375 6.83594 7.34375 6.57031V6.14062C7.34375 5.88281 7.25781 5.79688 6.99219 5.79688H6.5625C6.29688 5.79688 6.21094 5.88281 6.21094 6.14062V6.57031C6.21094 6.83594 6.29688 6.91406 6.5625 6.91406ZM9 6.91406H9.4375C9.69531 6.91406 9.78125 6.83594 9.78125 6.57031V6.14062C9.78125 5.88281 9.69531 5.79688 9.4375 5.79688H9C8.74219 5.79688 8.65625 5.88281 8.65625 6.14062V6.57031C8.65625 6.83594 8.74219 6.91406 9 6.91406ZM11.4453 6.91406H11.875C12.1406 6.91406 12.2266 6.83594 12.2266 6.57031V6.14062C12.2266 5.88281 12.1406 5.79688 11.875 5.79688H11.4453C11.1797 5.79688 11.0938 5.88281 11.0938 6.14062V6.57031C11.0938 6.83594 11.1797 6.91406 11.4453 6.91406ZM4.11719 9.3125H4.55469C4.8125 9.3125 4.89844 9.23438 4.89844 8.97656V8.53906C4.89844 8.28125 4.8125 8.20312 4.55469 8.20312H4.11719C3.85938 8.20312 3.77344 8.28125 3.77344 8.53906V8.97656C3.77344 9.23438 3.85938 9.3125 4.11719 9.3125ZM6.5625 9.3125H6.99219C7.25781 9.3125 7.34375 9.23438 7.34375 8.97656V8.53906C7.34375 8.28125 7.25781 8.20312 6.99219 8.20312H6.5625C6.29688 8.20312 6.21094 8.28125 6.21094 8.53906V8.97656C6.21094 9.23438 6.29688 9.3125 6.5625 9.3125ZM9 9.3125H9.4375C9.69531 9.3125 9.78125 9.23438 9.78125 8.97656V8.53906C9.78125 8.28125 9.69531 8.20312 9.4375 8.20312H9C8.74219 8.20312 8.65625 8.28125 8.65625 8.53906V8.97656C8.65625 9.23438 8.74219 9.3125 9 9.3125ZM11.4453 9.3125H11.875C12.1406 9.3125 12.2266 9.23438 12.2266 8.97656V8.53906C12.2266 8.28125 12.1406 8.20312 11.875 8.20312H11.4453C11.1797 8.20312 11.0938 8.28125 11.0938 8.53906V8.97656C11.0938 9.23438 11.1797 9.3125 11.4453 9.3125ZM4.11719 11.7188H4.55469C4.8125 11.7188 4.89844 11.6406 4.89844 11.3828V10.9453C4.89844 10.6875 4.8125 10.6094 4.55469 10.6094H4.11719C3.85938 10.6094 3.77344 10.6875 3.77344 10.9453V11.3828C3.77344 11.6406 3.85938 11.7188 4.11719 11.7188ZM6.5625 11.7188H6.99219C7.25781 11.7188 7.34375 11.6406 7.34375 11.3828V10.9453C7.34375 10.6875 7.25781 10.6094 6.99219 10.6094H6.5625C6.29688 10.6094 6.21094 10.6875 6.21094 10.9453V11.3828C6.21094 11.6406 6.29688 11.7188 6.5625 11.7188ZM9 11.7188H9.4375C9.69531 11.7188 9.78125 11.6406 9.78125 11.3828V10.9453C9.78125 10.6875 9.69531 10.6094 9.4375 10.6094H9C8.74219 10.6094 8.65625 10.6875 8.65625 10.9453V11.3828C8.65625 11.6406 8.74219 11.7188 9 11.7188Z"
      fill="#003C7D"
    />
  </svg>
)

const ProgrammedVCLegendIcon = () => (
  <svg
    width="40"
    height="18"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="14"
      cy="8"
      r="3"
      fill="white"
      stroke="#1666B6"
      strokeWidth="2"
    />
    <circle cx="4" cy="8" r="3" fill="white" stroke="#BB1669" strokeWidth="2" />
  </svg>
)

const UsedVCLegendIcon = () => (
  <svg
    width="40"
    height="18"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 5H14M18 5H14M14 5V11M14 11H18M14 11H10"
      stroke="#8BB3DB"
      strokeWidth="2"
    />
    <path
      d="M0 5H4M8 5H4M4 5V11M4 11H8M4 11H0"
      stroke="#DD8AB4"
      strokeWidth="2"
    />
  </svg>
)

const GoBackIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 17.6001L8.8 12.4001L14 7.2001"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const SelectCheckmark = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="17.5"
      cy="18.4492"
      r="16.75"
      stroke="#43A047"
      strokeWidth="1.5"
    />
    <path
      d="M8.94565 18.7547L14.7156 24.4577L26.0543 13.186"
      stroke="#43A047"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const ManualIcon = () => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.7385 8.04538L14.1003 7.70025L14.1003 7.70019L14.1 7.69997L14.0992 7.69909L14.0959 7.69562L14.083 7.68207L14.0336 7.6304L13.8551 7.44342C13.7058 7.28722 13.5032 7.0753 13.2897 6.85251C12.8651 6.40943 12.3906 5.91619 12.2128 5.73836C11.6453 5.17083 10.9569 4.5249 10.073 4.21124L10.0722 4.21096C9.59697 4.04323 9.0955 3.95991 8.59523 3.95991H8.59494H8.59465H8.59436H8.59407H8.59379H8.5935H8.59321H8.59293H8.59264H8.59236H8.59207H8.59179H8.59151H8.59122H8.59094H8.59066H8.59038H8.5901H8.58982H8.58954H8.58926H8.58899H8.58871H8.58843H8.58815H8.58788H8.5876H8.58733H8.58705H8.58678H8.58651H8.58623H8.58596H8.58569H8.58542H8.58514H8.58487H8.5846H8.58433H8.58407H8.5838H8.58353H8.58326H8.58299H8.58273H8.58246H8.58219H8.58193H8.58166H8.5814H8.58114H8.58087H8.58061H8.58035H8.58008H8.57982H8.57956H8.5793H8.57904H8.57878H8.57852H8.57826H8.578H8.57774H8.57749H8.57723H8.57697H8.57672H8.57646H8.5762H8.57595H8.57569H8.57544H8.57518H8.57493H8.57468H8.57442H8.57417H8.57392H8.57367H8.57342H8.57317H8.57291H8.57266H8.57241H8.57217H8.57192H8.57167H8.57142H8.57117H8.57092H8.57068H8.57043H8.57018H8.56994H8.56969H8.56945H8.5692H8.56896H8.56871H8.56847H8.56822H8.56798H8.56774H8.56749H8.56725H8.56701H8.56677H8.56653H8.56629H8.56605H8.5658H8.56556H8.56532H8.56509H8.56485H8.56461H8.56437H8.56413H8.56389H8.56365H8.56342H8.56318H8.56294H8.56271H8.56247H8.56224H8.562H8.56176H8.56153H8.5613H8.56106H8.56083H8.56059H8.56036H8.56013H8.55989H8.55966H8.55943H8.55919H8.55896H8.55873H8.5585H8.55827H8.55804H8.55781H8.55758H8.55734H8.55711H8.55688H8.55665H8.55643H8.5562H8.55597H8.55574H8.55551H8.55528H8.55505H8.55483H8.5546H8.55437H8.55414H8.55392H8.55369H8.55346H8.55324H8.55301H8.55278H8.55256H8.55233H8.55211H8.55188H8.55166H8.55143H8.55121H8.55098H8.55076H8.55054H8.55031H8.55009H8.54986H8.54964H8.54942H8.54919H8.54897H8.54875H8.54853H8.5483H8.54808H8.54786H8.54764H8.54741H8.54719H8.54697H8.54675H8.54653H8.54631H8.54609H8.54587H8.54564H8.54542H8.5452H8.54498H8.54476H8.54454H8.54432H8.5441H8.54388H8.54366H8.54344H8.54322H8.543H8.54278H8.54256H8.54235H8.54213H8.54191H8.54169H8.54147H8.54125H8.54103H8.54081H8.54059H8.54038H8.54016H8.53994H8.53972H8.5395H8.53928H8.53907H8.53885H8.53863H8.53841H8.53819H8.53798H8.53776H8.53754H8.53732H8.53711H8.53689H8.53667H8.53645H8.53623H8.53602H8.5358H8.53558H8.53537H8.53515H8.53493H8.53471H8.5345H8.53428H8.53406H8.53384H8.53363H8.53341H8.53319H8.53297H8.53276H8.53254H8.53232H8.5321H8.53189H8.53167H8.53145H8.53124H8.53102H8.5308H8.53058H8.53037H8.53015H8.52993H8.52971H8.52949H8.52928H8.52906H8.52884H8.52862H8.52841H8.52819H8.52797H8.52775H8.52753H8.52732H8.5271H8.52688H8.52666H8.52644H8.52622H8.52601H8.52579H8.52557H8.52535H8.52513H8.52491H8.52469H8.52447H8.52425H8.52403H8.52382H8.5236H8.52338H8.52316H8.52294H8.52272H8.5225H8.52228H8.52206H8.52184H8.52162H8.52139H8.52117H8.52095H8.52073H8.52051H8.52029H8.52007H8.51985H8.51962H8.5194H8.51918H8.51896H8.51874H8.51851H8.51829H8.51807H8.51785H8.51762H8.5174H8.51718H8.51695H8.51673H8.51651H8.51628H8.51606H8.51583H8.51561H8.51538H8.51516H8.51493H8.51471H8.51448H8.51426H8.51403H8.51381H8.51358H8.51335H8.51313H8.5129H8.51267H8.51245H8.51222H8.51199H8.51176H8.51154H8.51131H8.51108H8.51085H8.51062H8.51039H8.51016H8.50993H8.5097H8.50947H8.50924H8.50901H8.50878H8.50855H8.50832H8.50809H8.50786H8.50762H8.50739H8.50716H8.50693H8.50669H8.50646H8.50623H8.50599H8.50576H8.50552H8.50529H8.50505H8.50482H8.50458H8.50435H8.50411H8.50387H8.50364H8.5034H8.50316H8.50292H8.50269H8.50245H8.50221H8.50197H8.50173H8.50149H8.50125H8.50101H8.50077H8.50053H8.50029H8.50005H8.49981H8.49957H8.49932H8.49908H8.49884H8.49859H8.49835H8.49811H8.49786H8.49762H8.49737H8.49713H8.49688H8.49663H8.49639H8.49614H8.49589H8.49565H8.4954H8.49515H8.4949H8.49465H8.4944H8.49415H8.4939H8.49365H8.4934H8.49315H8.4929H8.49265H8.49239H8.49214H8.49189H8.49163H8.49138H8.49112H8.49087H8.49061H8.49036H8.4901H8.48985H8.48959H8.48933H8.48907H8.48882H8.48856H8.4883H8.48804H8.48778H8.48752H8.48726H8.487H8.48673H8.48647H8.48621H8.48595H8.48568H8.48542H8.48515H8.48489H8.48462H8.48436H8.48409H8.48382H8.48356H8.48329H8.48302H8.48275H8.48248H8.48221H8.48194H8.48167H8.4814H8.48113H8.48086H8.48059H8.48031H8.48004H8.47976H8.47949H8.47922H8.47894H8.47866H8.47839H8.47811H8.47783H8.47755H8.47728H8.477H8.47672H8.47644H8.47616H8.47587H8.47559H8.47531H8.47503H8.47474H8.47446H8.47418H8.47389H8.47361H8.47332H8.47303H8.47274H8.47246H8.47217H8.47188H8.47159H8.46073L8.44987 3.96038C6.43076 4.04817 4.9054 5.87222 4.9054 8.02065C4.9054 10.142 6.42868 11.993 8.44987 12.0809L8.46073 12.0814H8.47159H8.47174H8.47188H8.47203H8.47217H8.47232H8.47247H8.47262H8.47277H8.47292H8.47307H8.47322H8.47337H8.47352H8.47367H8.47383H8.47398H8.47413H8.47429H8.47444H8.4746H8.47475H8.47491H8.47507H8.47523H8.47538H8.47554H8.4757H8.47586H8.47602H8.47618H8.47634H8.4765H8.47667H8.47683H8.47699H8.47716H8.47732H8.47748H8.47765H8.47782H8.47798H8.47815H8.47831H8.47848H8.47865H8.47882H8.47899H8.47916H8.47933H8.4795H8.47967H8.47984H8.48001H8.48018H8.48035H8.48053H8.4807H8.48087H8.48105H8.48122H8.4814H8.48157H8.48175H8.48193H8.4821H8.48228H8.48246H8.48264H8.48281H8.48299H8.48317H8.48335H8.48353H8.48371H8.48389H8.48407H8.48426H8.48444H8.48462H8.4848H8.48499H8.48517H8.48535H8.48554H8.48572H8.48591H8.48609H8.48628H8.48647H8.48665H8.48684H8.48703H8.48722H8.4874H8.48759H8.48778H8.48797H8.48816H8.48835H8.48854H8.48873H8.48892H8.48911H8.48931H8.4895H8.48969H8.48988H8.49007H8.49027H8.49046H8.49066H8.49085H8.49104H8.49124H8.49143H8.49163H8.49183H8.49202H8.49222H8.49241H8.49261H8.49281H8.49301H8.49321H8.4934H8.4936H8.4938H8.494H8.4942H8.4944H8.4946H8.4948H8.495H8.4952H8.4954H8.4956H8.4958H8.49601H8.49621H8.49641H8.49661H8.49682H8.49702H8.49722H8.49743H8.49763H8.49783H8.49804H8.49824H8.49845H8.49865H8.49886H8.49906H8.49927H8.49947H8.49968H8.49989H8.50009H8.5003H8.50051H8.50071H8.50092H8.50113H8.50134H8.50155H8.50175H8.50196H8.50217H8.50238H8.50259H8.5028H8.50301H8.50322H8.50343H8.50364H8.50385H8.50406H8.50427H8.50448H8.50469H8.5049H8.50511H8.50532H8.50554H8.50575H8.50596H8.50617H8.50638H8.5066H8.50681H8.50702H8.50723H8.50745H8.50766H8.50787H8.50808H8.5083H8.50851H8.50873H8.50894H8.50915H8.50937H8.50958H8.5098H8.51001H8.51022H8.51044H8.51065H8.51087H8.51108H8.5113H8.51151H8.51173H8.51194H8.51216H8.51238H8.51259H8.51281H8.51302H8.51324H8.51345H8.51367H8.51389H8.5141H8.51432H8.51454H8.51475H8.51497H8.51518H8.5154H8.51562H8.51583H8.51605H8.51627H8.51648H8.5167H8.51692H8.51714H8.51735H8.51757H8.51779H8.518H8.51822H8.51844H8.51866H8.51887H8.51909H8.51931H8.51952H8.51974H8.51996H8.52018H8.52039H8.52061H8.52083H8.52105H8.52126H8.52148H8.5217H8.52191H8.52213H8.52235H8.52257H8.52278H8.523H8.52322H8.52344H8.52365H8.52387H8.52409H8.5243H8.52452H8.52474H8.52495H8.52517H8.52539H8.52561H8.52582H8.52604H8.52626H8.52647H8.52669H8.52691H8.52712H8.52734H8.52755H8.52777H8.52799H8.5282H8.52842H8.52864H8.52885H8.52907H8.52928H8.5295H8.52972H8.52993H8.53015H8.53036H8.53058H8.53079H8.53101H8.53122H8.53144H8.53165H8.53187H8.53208H8.53229H8.53251H8.53272H8.53294H8.53315H8.53336H8.53358H8.53379H8.53401H8.53422H8.53443H8.53465H8.53486H8.53507H8.53528H8.5355H8.53571H8.53592H8.53613H8.53634H8.53656H8.53677H8.53698H8.53719H8.5374H8.53761H8.53782H8.53803H8.53824H8.53845H8.53866H8.53887H8.53908H8.53929H8.5395H8.53971H8.53992H8.54013H8.54034H8.54054H8.54075H8.54096H8.54117H8.54138H8.54158H8.54179H8.542H8.5422H8.54241H8.54262H8.54282H8.54303H8.54323H8.54344H8.54364H8.54385H8.54405H8.54426H8.54446H8.54466H8.54487H8.54507H8.54527H8.54548H8.54568H8.54588H8.54608H8.54629H8.54649H8.54669H8.54689H8.54709H8.54729H8.54749H8.54769H8.54789H8.54809H8.54829H8.54849H8.54869H8.54889H8.54908H8.54928H8.54948H8.54968H8.54987H8.55007H8.55026H8.55046H8.55066H8.55085H8.55105H8.55124H8.55143H8.55163H8.55182H8.55202H8.55221H8.5524H8.55259H8.55279H8.55298H8.55317H8.55336H8.55355H8.55374H8.55393H8.55412H8.55431H8.5545H8.55469H8.55487H8.55506H8.55525H8.55544H8.55562H8.55581H8.556H8.55618H8.55637H8.55655H8.55674H8.55692H8.5571H8.55729H8.55747H8.55765H8.55783H8.55802H8.5582H8.55838H8.55856H8.55874H8.55892H8.5591H8.55928H8.55945H8.55963H8.55981H8.55999H8.56016H8.56034H8.56052H8.56069H8.56087H8.56104H8.56122H8.56139H8.56156H8.56174H8.56191H8.56208H8.56225H8.56242H8.56259H8.56276H8.56293H8.5631H8.56327H8.56344H8.56361H8.56378H8.56394H8.56411H8.56428H8.56444H8.56461H8.56477H8.56493H8.5651H8.56526H8.56542H8.56559H8.56575H8.56591H8.56607H8.56623H8.56639H8.56655H8.56671H8.56686H8.56702H8.56718H8.56734H8.56749H8.56765H8.5678H8.56796H8.56811H8.56826H8.56842H8.56857H8.56872H8.56887H8.56902H8.56917H8.56932H8.56947H8.56962H8.56977H8.56992H8.57006H8.57021H8.57035H8.5705C9.07077 12.0814 9.57224 11.9981 10.0475 11.8303L10.0483 11.8301C10.9322 11.5164 11.6205 10.8705 12.1881 10.3029L13.2699 9.22112L13.8433 8.64775L14.0245 8.46654L14.0745 8.41651L14.0876 8.40341L14.0909 8.40006L14.0918 8.39921L14.092 8.399L14.0921 8.39895L13.7385 8.04538ZM13.7385 8.04538L14.1003 7.70027L14.4374 8.05363L14.0921 8.39893L13.7385 8.04538ZM1.77009 10.4449L1.76599 10.4337L1.76136 10.4227C1.3748 9.50605 1.33189 8.38957 1.41849 7.41909C1.50499 6.44969 1.71353 5.6978 1.76881 5.55038L1.76883 5.55039L1.77009 5.54695C2.02131 4.8618 2.38698 4.21961 2.87037 3.61953C3.36223 3.05852 3.92074 2.54752 4.52078 2.13114C5.16941 1.71518 5.88727 1.39143 6.62687 1.18321C7.38207 0.9775 8.19312 0.905992 8.99311 0.928907C9.76326 0.976205 10.5285 1.11594 11.2673 1.3689C11.9801 1.64594 12.6548 2.04033 13.2914 2.51171C13.9502 3.00599 14.5189 3.57354 15.1406 4.19528L17.0412 6.09584C17.3473 6.41435 17.8677 6.97146 18.3147 7.45232C18.5049 7.65702 18.6813 7.84724 18.8212 7.9983C18.6836 8.1487 18.5103 8.33761 18.3228 8.54079C17.8767 9.02398 17.3579 9.57928 17.0446 9.89256L15.1442 11.793C15.0151 11.917 14.8892 12.0398 14.765 12.1609C14.277 12.6369 13.8156 13.087 13.2902 13.481L13.283 13.4864L13.276 13.4921C12.6718 13.9801 12.0051 14.3693 11.2763 14.6198L11.2673 14.6229L11.2584 14.6264C10.5523 14.8997 9.76869 15.0394 9.00045 15.0627L8.99333 15.0629L8.98623 15.0634C8.20322 15.1094 7.3921 15.0173 6.62496 14.8081C5.85439 14.598 5.16453 14.2976 4.52396 13.8629L4.52056 13.8606C3.88865 13.4394 3.3355 12.9536 2.878 12.3818C2.41332 11.8009 2.02148 11.1305 1.77009 10.4449Z"
      fill="white"
      stroke="#333333"
    />
  </svg>
)

const MaskIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.06092 10.3116C4.06092 8.92427 4.95897 7.72246 6.24562 7.40013C10.4431 6.34856 13.6502 6.25839 17.8515 7.36465C19.0854 7.68956 19.9392 8.86216 19.9392 10.2178V14.5991C19.9392 15.9272 19.1175 17.0876 17.9101 17.4482C13.5276 18.7566 10.3775 18.7493 6.07856 17.4539C4.87729 17.0919 4.06092 15.9345 4.06092 14.6104V10.3116Z"
      stroke="#333333"
      stroke-width="1.74"
    />
    <line
      x1="6.97718"
      y1="12.2355"
      x2="17.0234"
      y2="12.2355"
      stroke="#999999"
      strokeWidth="1.74"
      strokeLinecap="round"
    />
    <path
      d="M6.48462 9.62786C11.0132 8.75325 13.4377 8.73778 17.5158 9.62791"
      stroke="#999999"
      strokeWidth="1.74"
      strokeLinecap="round"
    />
    <path
      d="M17.5159 15.372C12.9873 16.2466 10.5628 16.2621 6.48471 15.372"
      stroke="#999999"
      strokeWidth="1.74"
      strokeLinecap="round"
    />
    <path
      d="M3.60342 16.0339C0.808243 15.281 0.798604 9.73689 3.60342 8.96616"
      stroke="#333333"
      strokeWidth="1.74"
      strokeLinecap="round"
    />
    <path
      d="M20.3966 8.96606C23.1918 9.71904 23.2014 15.2631 20.3966 16.0338"
      stroke="#333333"
      strokeWidth="1.74"
      strokeLinecap="round"
    />
  </svg>
)

export {
  NormalIcon,
  FavoriteStar,
  RestaurantIcon,
  MusicIcon,
  TheaterIcon,
  TvIcon,
  MeetingIcon,
  NotificationBell,
  AppRatingStar,
  CrowdIcon,
  PhoneIcon,
  Preset1Icon,
  Preset2Icon,
  Preset3Icon,
  Preset4Icon,
  ChevronRight,
  ChargerIcon,
  HIRight,
  HILeft,
  CalendarIcon,
  UsedVCLegendIcon,
  ProgrammedVCLegendIcon,
  GoBackIcon,
  SelectCheckmark,
  ManualIcon,
  MaskIcon,
}
